'use strict';

/**
* @ngdoc service
* @name tcApp.WebsysCurrencyLegacyScope
* @description
* Contains systemUI equivalents for legacy currency functions originally
* defined in websys.Component
*
*/
angular.module('tc.legacyScope').factory('WebsysCurrencyLegacyScope', function($window, GlobalService) {
	/* eslint no-unused-vars:0 */
	return function($scope) {
		var currencyConfiguration = {};
		if (angular.isDefined(GlobalService.configuration.currency)) {
			currencyConfiguration = GlobalService.configuration.currency;
		}
		// curydecimalsym / curygroupsym variables are defined by componentScriptService.js
		
		// Returns whether a field has a valid currency value
		var isValidCurrency = function(item) {
			if (!item) return true;
			if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return true;
			if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName][item.id])) return true;
			
			// Validation is handled by validate.js, just check for invalid model state
			if ($scope.componentForm[$scope.componentHtmlName][item.id].$error['number']) {
				return false;
			}
			
			return true;
		};
		
		// CurrencyRound function rounds value to system defined number of 
		// decimal places and also adds grouping symbols
		var currencyRound = function(flt) {
			var decimalSymbol = currencyConfiguration.decimalSymbol;
			var decimalPlaces = currencyConfiguration.decimalPlaces;

			var bNeg = false;
			var RoundedNum = '';
			var fltStr = flt.toString();
			var fltArr = fltStr.split('.');
			if (fltArr[0]) {
				fltArr[0] = fltArr[0].replace(' ', '');
				if (fltArr[0] == '') fltArr[0] = '0';
			} else {
				fltArr[0] = '0';
			}
			if (fltArr[1]) {
				if ((flt.toString().length - flt.toString().lastIndexOf(decimalSymbol)) > (parseFloat(decimalPlaces + 1))) {
					var Rounder = Math.pow(10, decimalPlaces);
					var fltJS = flt.toString().replace(decimalSymbol, '.');
					RoundedNum = Math.round(fltJS * Rounder) / Rounder;
					var RoundedNumStr = RoundedNum.toString();
					if (decimalSymbol != '.') RoundedNumStr = RoundedNumStr.replace('.', decimalSymbol);
					var RoundedNumArr = RoundedNumStr.split(decimalSymbol);
					if (!(RoundedNumArr[1])) {
						RoundedNumArr[1] = '';
					}
					for (var j = 1; RoundedNumArr[1].length < decimalPlaces; j++) {
						RoundedNumArr[1] += '0';
					}
					// Case 0.000000 does not get rounded correctly
					if (RoundedNumArr[1].length > decimalPlaces) RoundedNumArr[1] = RoundedNumArr[1].substring(0, decimalPlaces);
					RoundedNumArr[0] = addGroupingSymbol(RoundedNumArr[0]);

					if (decimalPlaces > 0) {
						RoundedNum = RoundedNumArr.join(decimalSymbol);
					} else {
						RoundedNum = RoundedNumArr[0];
					}

					return RoundedNum;
				}
			} else {
				fltArr[1] = '';
			}
			for (var i = 1; fltArr[1].length < decimalPlaces; i++) {
				fltArr[1] += '0';
			}
			fltArr[0] = addGroupingSymbol(fltArr[0]);

			if (decimalPlaces > 0) {
				fltStr = fltArr.join(decimalSymbol);
			} else {
				fltStr = fltArr[0];
			}

			return fltStr;
		};
		
		// AddGroupingSymbol will add the system defined grouping symbol when passed in to
		// the integer part of the number (decimal part must NOT be passed). The group
		// length is fixed to 3. We may need to add a new system param if we run into
		// sites which group by 2.
		var addGroupingSymbol = function(number) {
			var currencyGroupSymbol = currencyConfiguration.groupingSymbol;
			
			number = '' + number;
			if (number.length > 3) {
				var mod = number.length % 3;
				var output = (mod > 0 ? (number.substring(0, mod)) : '');
				for (var i = 0; i < Math.floor(number.length / 3); i++) {
					if ((mod == 0) && (i == 0)) {
						output += number.substring(mod + 3 * i, mod + 3 * i + 3);
					} else {
						output += currencyGroupSymbol + number.substring(mod + 3 * i, mod + 3 * i + 3);
					}
				}
				if (output.substring(0, 2) == '-' + currencyGroupSymbol) {
					output = '-' + output.substring(2, output.length);
				}
				return (output);
			} else { 
				return number;
			}
		};
		
		// This function will format the Medtrak currency into a string
		// that JS recognises, before Math function is called
		// (JS Math class functions don't recognise decimal commas)
		var medtrakCurrToJSMath = function(StrNum) {
			var decimalSymbol = currencyConfiguration.decimalSymbol;
			var currencyGroupSymbol = currencyConfiguration.groupingSymbol;
			
			var result = '';
			result = StrNum.replace(/ /g, '');
			if (result == '') {
				result = '0';
			} else {
				var re;
				if (currencyGroupSymbol === '.') {
					re = /\./g;
				} else {
					re = /,/g;
				}
				result = result.replace(re, '');
				if ((decimalSymbol != '.') && (result.indexOf(decimalSymbol) != -1)) {
					result = result.replace(decimalSymbol, '.');
				}
			}
			return result;
		};
		
		// Function to subtract Currency Values
		// Up to 2 numbers can be subtracted from the first.
		var subtractCurrencyValues = function(StrNum1, StrNum2, StrNum3) {
			var strRemainder = '';
			var Str1 = ((!StrNum1) ? '0' : medtrakCurrToJSMath(StrNum1));
			var Str2 = ((!StrNum2) ? '0' : medtrakCurrToJSMath(StrNum2));
			var Str3 = ((!StrNum3) ? '0' : medtrakCurrToJSMath(StrNum3));
			strRemainder = currencyRound(parseFloat(Str1) - parseFloat(Str2) - parseFloat(Str3));
			return strRemainder;
		};
		
		// Function to add Medtrak Currency Values
		// Up to 3 numbers can added
		var addCurrencyValues = function(StrNum1, StrNum2, StrNum3) {
			var strAddTotal = '';
			var Str1 = ((!StrNum1) ? '0' : medtrakCurrToJSMath(StrNum1));
			var Str2 = ((!StrNum2) ? '0' : medtrakCurrToJSMath(StrNum2));
			var Str3 = ((!StrNum3) ? '0' : medtrakCurrToJSMath(StrNum3));
			strAddTotal = currencyRound(parseFloat(Str1) + parseFloat(Str2) + parseFloat(Str3));
			return strAddTotal;
		};
		
		/* websys.js functions */
		
		/// returns a number [val] rounded to the required number of significant figures [sigfigs] 
		/// val could be either a numerical string or a properly casted number (integer or fractional)
		/// if sigfigs is not defined, invalid, blank or 0, will use the system parameter definition
		/// will return the value rounded to system defined precision as a numerical string for display
		/// unless [returnAsLogical] is 1 (boolean), will return as rounded precision for use for further calculations
		/// (cast as Number object, always decimal dot)
		function websysFloatToSigFig(val, sigfigs, returnAsLogical) {
			if (angular.isUndefined(sigfigs)) sigfigs = '';
			if (angular.isUndefined(returnAsLogical)) returnAsLogical = 0;
			
			val = val.toString(); //val is now a numerical string object
			val = val.trim();
			if (val === '') return val;
			
			val = $window.cspHttpServerMethod(GlobalService.serverMethods[0], 'websys.SYSTEM',
			'', 'FloatLogicalToSigFigsHtml', val, sigfigs, 0, returnAsLogical);
			
			if (returnAsLogical) return parseFloat(val, 10);
			return val;
		}
		
		// Returns whether a field has a positive value
		var isPositiveNumber = function(item) {
			if (angular.isUndefined(item)) return false;
			if ((item.value !== '') && (item.value < 0)) return false;
			return true;
		};
		
		// Return all the functions in an object
		var websysCurrencyFunctions = {
			/* websys.Component functions */
			'IsValidCurrency': isValidCurrency,
			'CurrencyRound': currencyRound,
			'AddGroupingSymbol': addGroupingSymbol,
			'MedtrakCurrToJSMath': medtrakCurrToJSMath,
			'SubtractCurrencyValues': subtractCurrencyValues,
			'AddCurrencyValues': addCurrencyValues,
			'IsValidInteger': isValidCurrency,
			'IsValidNumber': isValidCurrency,
			'IsPositiveNumber': isPositiveNumber,
			
			/* websys.js functions */
			'websys_FloatToSigFig': websysFloatToSigFig
		};
		
		return websysCurrencyFunctions;
	};
});
